/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class TabSwitcher extends HTMLElement {
  connectedCallback() {
    this.initTabs(this);
    this.initActiveSubTabs();
  }
  initTabs(container) {
    const tabButtons = container.querySelectorAll(':scope .tabs-navigation .tab-button');
    tabButtons.forEach(button => {
      button.addEventListener('click', () => this.onTabClick(button));
    });
    const sliders = container.querySelectorAll('[is="scroll-snap-slider"]');
    sliders.forEach(slider => this.setupSlider(slider));
  }
  onTabClick(button) {
    const targetTab = button.dataset.tab;
    const parentContent = button.closest('.tab-content, tab-switcher') || this;
    button.parentNode.querySelectorAll('.tab-button').forEach(btn => {
      btn.classList.remove('active');
      btn.removeAttribute('aria-selected');
    });
    parentContent.querySelectorAll(':scope > .tab-content').forEach(content => content.classList.remove('active'));
    button.classList.add('active');
    button.setAttribute('aria-selected', 'true');
    const activeTabContent = parentContent.querySelector('#tab-content-' + targetTab);
    if (!activeTabContent) return;
    activeTabContent.classList.add('active');
    this.resetSliderInTab(activeTabContent);
    if (activeTabContent.querySelector('.tabs-navigation')) {
      this.initTabs(activeTabContent);
    }
  }
  initActiveSubTabs() {
    const activeParent = this.querySelector('.tab-content.active');
    if (activeParent && activeParent.querySelector('.tabs-navigation')) {
      this.initTabs(activeParent);
    }
  }
  setupSlider(slider) {
    if (!slider) return;
    slider.style.scrollSnapType = 'x mandatory';
    slider.style.overflowX = 'auto';
    slider.style.scrollBehavior = 'smooth';
    slider.style.display = 'flex';
    const items = Array.from(slider.children);
    items.forEach(item => {
      item.style.scrollSnapAlign = 'start';
      item.style.flexShrink = '0';
    });
    const container = slider.closest('.slider-mobile-gutter') || slider.parentNode;
    const prevButton = container.querySelector('.slider-button--prev');
    const nextButton = container.querySelector('.slider-button--next');
    if (!prevButton || !nextButton) return;
    let currentSlide = 0;
    const totalSlides = items.length;
    const getVisibleItems = () => {
      const sliderWidth = slider.offsetWidth;
      const itemWidth = items[0]?.offsetWidth || 1;
      return Math.floor(sliderWidth / itemWidth) || 1;
    };
    const updateButtonStates = () => {
      const visibleItems = getVisibleItems();
      const maxSlide = Math.max(0, totalSlides - visibleItems);
      prevButton.disabled = currentSlide <= 0;
      nextButton.disabled = currentSlide >= maxSlide;
    };
    const slideTo = index => {
      const visibleItems = getVisibleItems();
      const maxSlide = Math.max(0, totalSlides - visibleItems);
      currentSlide = Math.max(0, Math.min(index, maxSlide));
      items[currentSlide]?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
      updateButtonStates();
    };
    prevButton.addEventListener('click', () => slideTo(currentSlide - 1));
    nextButton.addEventListener('click', () => slideTo(currentSlide + 1));
    slider._sliderFunctions = {
      slideTo,
      updateButtonStates,
      reset: () => {
        currentSlide = 0;
        slideTo(0);
      }
    };
  }
  resetSliderInTab(tabContent) {
    const slider = tabContent.querySelector('[is="scroll-snap-slider"]');
    if (slider && slider._sliderFunctions) slider._sliderFunctions.reset();
  }
}
if (!customElements.get('tab-switcher')) {
  customElements.define('tab-switcher', TabSwitcher);
}
/******/ })()
;